import React from "react";
import PrimaryButton from "../../components/PrimaryButton";
import { capitalizeFirstLetter } from "../../utils/helpers";
import EditIcon from "@mui/icons-material/Edit";
import { Card, Col, Form, Row } from "react-bootstrap";
import SelectDropdown from "../../components/SelectDropdown";
import CloseIcon from "@mui/icons-material/Close";
import GenerateModal from "../../components/GenerateModal";
import { rolesData } from "../../constants/Roles";
import useUserManagementViewViewController from "../../viewControllers/UserManagementViewControllers/UserManagementViewViewController";
import Loader from "../../components/Loader";
import i18n from "../../constants/Strings";
import InputField from "../../components/InputField";

const UserManagementView = () => {

  const {
    goBack,
    handleSubmit,
    handleSelectedEmployee,
    values,
    editState,
    setEditState,
    showModal,
    editEmailState,
    setEditEmailState,
    setShowModal,
    generatedPassword,
    userData,
    state,
    loading,
    handleChange
  } = useUserManagementViewViewController();

  const text = {
    backBtn: i18n.t('userManagement.userManagementView.backBtn'),
    userDetails: i18n.t('userManagement.userManagementView.userDetails'),
    employeeName: i18n.t('userManagement.userManagementView.employeeName'),
    username: i18n.t('userManagement.userManagementView.username'),
    assignedRole: i18n.t('userManagement.userManagementView.assignedRole'),
    updateRole: i18n.t('userManagement.userManagementView.updateRole'),
    generatePassword: i18n.t('userManagement.userManagementView.generatePassword'),
    updateBtn: i18n.t('userManagement.userManagementView.updateBtn'),
    email: i18n.t('userManagement.userManagementView.email'),


  }

  console.log('values', values)
  return (
    <>
      {loading ? <Loader /> : (
        <div className="container-fluid mt-5">
          <div className="mb-4">
            <div className="card-header py-3">
              <h6 className="back-btn" onClick={goBack}>{text.backBtn}</h6>
              <h6 className="m-0 font-weight-bold txt-primary">
                {text.userDetails}
              </h6>
            </div>

            <Card style={{ width: "100%", height: "500px" }}>
              <Form className="mt-4 mb-4 px-4" onSubmit={handleSubmit}>
                <Row>
                  <Col className="col-lg-6">
                    <h5>
                      {text.employeeName}
                      <span className="fs-sm">{userData?.name ?? "-"}</span>{" "}
                    </h5>
                  </Col>
                  <Col className="col-lg-6">
                    <h5>
                      {text.username}
                      <span className="fs-sm">{userData?.username ?? "-"}</span>{" "}
                    </h5>
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col className="col-lg-6">
                    <h5>
                      {text.assignedRole}
                      <span className="fs-sm">
                        {userData?.role
                          ? capitalizeFirstLetter(userData?.role)
                          : ""}
                      </span>{" "}
                    </h5>
                  </Col>
                  <Col className="col-lg-6">
                    <h5>
                      {text.email}
                      <span className="fs-sm">{userData?.email ?? "-"}</span>{" "}
                    </h5>
                  </Col>
                </Row>
                {state?.view ? (
                  <>
                    <Row className=" mt-4">
                      <Col className=" col-lg-6">
                        <Row>
                          <Col className="col-lg-3 mt-3">
                            <p>{text.updateRole}</p>
                          </Col>
                          <Col className=" col-lg-8">
                            <SelectDropdown
                              isDisabled={editState}
                              placeholder="Select"
                              data={rolesData}
                              value={values?.role}
                              onChange={handleSelectedEmployee}
                            />
                          </Col>
                          <Col className="col-lg-1">
                            {editState === false ? (
                              <div
                                className="mt-2 cursor-pointer px-1"
                                onClick={() => setEditState(true)}
                              >
                                <CloseIcon fontSize="large" />
                              </div>
                            ) : (
                              <div
                                className="mt-2 cursor-pointer px-1"
                                onClick={() => setEditState(false)}
                              >
                                <EditIcon />
                              </div>
                            )}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row className=" mt-4">
                      <Col className=" col-lg-6">
                        <Row>
                          <Col className="col-lg-3 mt-3">
                            <p>Update Email</p>
                          </Col>
                          <Col className=" col-lg-8">
                            <InputField
                              type="email"
                              value={values?.updated_email}
                              disabled={editEmailState}
                              onChange={handleChange("updated_email")}
                              name="updated_email"
                            />
                          </Col>
                          <Col className="col-lg-1">
                            {editEmailState === false ? (
                              <div
                                className="mt-2 cursor-pointer px-1"
                                onClick={() => setEditEmailState(true)}
                              >
                                <CloseIcon fontSize="large" />
                              </div>
                            ) : (
                              <div
                                className="mt-2 cursor-pointer px-1"
                                onClick={() => setEditEmailState(false)}
                              >
                                <EditIcon />
                              </div>
                            )}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </>
                ) : (
                  <>
                    <Row className="mt-5 d-flex justify-content-center">
                      <PrimaryButton
                        type="submit"
                        text={text.generatePassword}
                        className="width-auto save-btn "
                      />
                    </Row>
                  </>
                )}
                {state?.view ? (
                  (!editState || !editEmailState) && (
                    <PrimaryButton
                      type="submit"
                      text={text.updateBtn}
                      disabled={(!editState && values?.role==="") || 
                        (!editEmailState && values?.updated_email==="") || 
                        (!editState && !editEmailState && values?.role==="" && values?.updated_email==="")}
                      className="width-auto save-btn"
                    />
                  )
                ) : null}
                {showModal ? (
                  <GenerateModal
                    setShowModal={setShowModal}
                    showModal={showModal}
                    password={generatedPassword}
                    handleSubmit={handleSubmit}
                  />
                ) : null}
              </Form>
            </Card>
          </div>
        </div>
      )}
    </>
  );
};

export default UserManagementView;
